<script>
	import { validate } from "$misc/actions";

	export let id = "checkbox";
	export let checked = false;
	export let label = "";

	export const trigger = () => {
		const node = document.querySelector(`#${id}`);
		node.focus();
		node.blur();
	};
</script>

<div class="form-group ">
	<div class="custom-control custom-checkbox">
		<input
			type="checkbox"
			name={id}
			{id}
			class="custom-control-input chk_active"
			bind:checked
			use:validate={"checkbox"}
		/>

		<label
			class="custom-control-label"
			for={id}
			style="color: #707070 !important"
		>
			<slot>{label}</slot>
		</label>
	</div>
</div>
